import loadable from '@loadable/component';
import { RouterLink } from '@/utilities/redux-first-router.export';

import { Grid, Box, Text, Button, useTheme } from '@simplywallst/ui-core';
import { DemoHoldingsOverview } from '../HoldingsOverview';

import { useSortedHoldings } from '../../hooks/useHoldingsSorting';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';

const DemoPortfolioOverview = loadable(() => import('../PortfolioOverview'), {
  resolveComponent: (c) => c.DemoPortfolioOverview,
  fallback: (
    <Grid
      templateRows="400px 400px"
      templateRowsMd="405px"
      templateColumnsMd="auto 32%"
      gap="16px"
    >
      <Grid backgroundColor="noir" borderRadius="x1" />
      <Grid backgroundColor="noir" borderRadius="x1" />
    </Grid>
  ),
});

interface Props {
  portfolio: Portfolio;
}

export const DemoHoldingsPanel = ({ portfolio }: Props) => {
  const theme = useTheme();

  const sortedHoldings = useSortedHoldings(portfolio.holdings);
  return (
    <Grid templateColumns="100vw" templateColumnsLg="auto">
      <Box
        marginRightMd="x0"
        marginLeftMd="x0"
        marginRight="x2"
        marginLeft="x2"
        marginBottom="x2"
        padding="x1_5"
        borderRadius="x1"
        backgroundColor="noir"
        data-cy-id="demo-portfolio-banner"
      >
        <Grid
          gap="8px"
          templateColumns="auto max-content"
          justifyContent="space-between"
        >
          <Grid
            gap="8px"
            templateColumns="24px auto"
            alignItems="start"
            alignItemsMd="center"
          >
            <InformationSolid fill={theme.color.warning} />
            <Text typography="xSmall">
              This is a demo portfolio. Explore all features and create your own
              when you’re ready.
            </Text>
          </Grid>
          <RouterLink to={{ type: ROUTE_PORTFOLIO_NEW }}>
            <Button styleType="louderLarge">Create your portfolio</Button>
          </RouterLink>
        </Grid>
      </Box>
      <section data-cy-id="portfolio-overview">
        <DemoPortfolioOverview portfolio={portfolio} />
      </section>
      <DemoHoldingsOverview
        portfolio={portfolio}
        sortedHoldings={sortedHoldings}
      />
    </Grid>
  );
};
